// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"236d4f8d","513":"8deaca50","703":"01fe199a","787":"e07e68c6"}[chunkId] + ".chunk.js";
};